import { api, defaultQueriesFor } from '../apiSlice';

export const blogCategoryApi = api
  .enhanceEndpoints({ addTagTypes: ['BlogCategory'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'BlogCategory', 'BlogCategories'),
    }),
  });

export const {
  useCreateBlogCategoryMutation,
  useDeleteBlogCategoryMutation,
  useGetBlogCategoriesQuery,
  useGetBlogCategoryByIdQuery,
  useUpdateBlogCategoryMutation,
} = blogCategoryApi;
